export default __webpack_public_path__ + "static/media/hummer.c24e76a4.svg";